/**
 * Created by robert.lavoie on 4/25/17.
 */

import { Component, ChangeDetectionStrategy, EventEmitter, Input, Output, ViewChild, OnChanges, SimpleChanges } from '@angular/core';

// Models
import { Site, LogoPosition, MenuLink } from '../../models';

/**
 *
 * @class
 * CustomerSiteHeaderComponent
 *
 * @description
 * The header background is styled according to the theme color
 * There is also an optional home button that links to the customers corporate site
 * The home button get added when the customer defines a homepageURL in the CMS
 *
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'customer-site-header',
  styleUrls: ['./customer-site-header.component.scss'],
  templateUrl: 'customer-site-header.component.html',
})
export class CustomerSiteHeaderComponent implements OnChanges {

  // The current site we are within
  @Input() site: Site;
  @Input() showBackButton: boolean = true;
  @Input() showSearchJobs: boolean = false;
  @Output() clickEvent: EventEmitter<string> = new EventEmitter();
  @Output() searchJobs: EventEmitter<null> = new EventEmitter();

  // Whether or not to show the logo on this component
  showLogo: boolean;

  // Toggle whether to open the mobile links menu
  openMobileLinks: boolean = false;

  headerLinks: MenuLink[];

  ngOnChanges(changes: SimpleChanges) {

    // Handle site changes
    if (changes.site) {
      // Site constant for reuse
      const site = changes.site.currentValue;

      // Run logo logic with the current site changes
      this.showLogo = this.shouldShowLogo(site, this.showBackButton);

      // Add header links
      this.headerLinks = (site.menu && site.menu.links) ? site.menu.links.filter(item => item.linkInHeader) : [];
    }

    // Handle showBackButton changes
    if (changes.showBackButton) {
      const backButton = changes.showBackButton.currentValue;
      this.showLogo = this.shouldShowLogo(this.site, backButton);
    }
  }

  /**
   * Helper function to determine whether or not to show the logo based on a current state
   * @param { Site } site - the current site being considered
   * @param { boolean } showBackButton - whether or not to show the back button
   */
  private shouldShowLogo(site: Site, showBackButton: boolean): boolean {
    // Define valid states
    const validStates: string[] = [
      LogoPosition.HEADER,
      LogoPosition.HEADER_AND_INTRO,
    ];

    // If the theme is one of our valid states, return true
    // Ensure we have a logo set and we are not showing the back button
    const validPosition = validStates.indexOf(site.theme.logoPosition) >= 0;
    return validPosition && site.theme.logo && !showBackButton;
  }
}
